/**
 * Cart reservation countdown — sessionStorage end time, M:SS display.
 */
if (!customElements.get('cart-reservation-timer')) {
  customElements.define(
    'cart-reservation-timer',
    class CartReservationTimer extends HTMLElement {
      connectedCallback() {
        this.durationSec = parseInt(this.getAttribute('data-duration'), 10) || 600;
        this.storageKey = this.getAttribute('data-storage-key') || 'cart-reservation-end';
        this.timeEl = this.querySelector('[data-reservation-time]');

        this.tick = this.tick.bind(this);
        this.onCartUpdate = this.onCartUpdate.bind(this);

        this.tick();
        this._interval = window.setInterval(this.tick, 1000);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          this._cartUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
        }
      }

      disconnectedCallback() {
        window.clearInterval(this._interval);
        if (this._cartUnsub) this._cartUnsub();
      }

      onCartUpdate(event) {
        const cartData = event && event.cartData;
        const itemCount =
          cartData && typeof cartData.item_count === 'number'
            ? cartData.item_count
            : null;

        if (itemCount === 0) {
          sessionStorage.removeItem(this.storageKey);
          this.hidden = true;
          this.setAttribute('hidden', '');
          return;
        }

        if (itemCount != null && itemCount > 0) {
          this.hidden = false;
          this.removeAttribute('hidden');
          if (!sessionStorage.getItem(this.storageKey)) {
            this.resetEndTime();
          }
        }

        this.tick();
      }

      resetEndTime() {
        sessionStorage.setItem(this.storageKey, String(Date.now() + this.durationSec * 1000));
      }

      ensureEndTime() {
        const stored = parseInt(sessionStorage.getItem(this.storageKey), 10);
        if (!stored || isNaN(stored)) {
          this.resetEndTime();
        }
      }

      formatRemaining(ms) {
        if (ms <= 0) return '0:00';
        const totalSec = Math.floor(ms / 1000);
        const m = Math.floor(totalSec / 60);
        const s = totalSec % 60;
        return m + ':' + String(s).padStart(2, '0');
      }

      tick() {
        const drawer = this.closest('cart-drawer');
        if (drawer && drawer.classList.contains('is-empty')) {
          this.hidden = true;
          this.setAttribute('hidden', '');
          return;
        }

        this.hidden = false;
        this.removeAttribute('hidden');
        this.ensureEndTime();

        const end = parseInt(sessionStorage.getItem(this.storageKey), 10);
        const rem = Math.max(0, end - Date.now());
        const label = this.formatRemaining(rem);

        if (this.timeEl) {
          this.timeEl.textContent = label;
          this.timeEl.setAttribute('datetime', 'PT' + Math.ceil(rem / 1000) + 'S');
        }
      }
    }
  );
}
